/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Asset} from '@ion/core/src/types/entities';
import {AssetBulkEditor} from '@ion/dls/src/editors/AssetBulkEditor';
import {editAdminAssets, editAssets} from './state';

export interface BulkAssetEditorProps {
  isCtcAdmin?: boolean;
  globalGroup: any;
}

/**
 * BulkEditAssetEditor
 *
 */
export const BulkEditAssetEditor = ({
  globalGroup,
  isCtcAdmin = false
}: BulkAssetEditorProps) => {
  const dispatch                    = useDispatch();
  const {
    selected: selectedAssets,
    result: editedAssets,
    loading
  }                                 = useSelector(({adminAssets: {bulkEdit}}) => bulkEdit);
  const [clearForm, setClearForm]   = useState(false);

  useEffect(() => {
    if (editedAssets) {
      setClearForm(true);
      dispatch(editAdminAssets(null, false));
    }
  }, [editedAssets]);

  return (
    <AssetBulkEditor open
      account={globalGroup}
      assets={selectedAssets}
      clear={clearForm}
      loading={loading}
      isCtcAdmin={isCtcAdmin}
      onSave={function(assets: Asset[]) {
        dispatch(editAssets(assets));
      }}
      onCancel={function() {
        dispatch(editAdminAssets(null, false));
      }} />
  );
};

export default BulkEditAssetEditor;
